import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useReducer, useCallback } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import CopilotSidebarAgentsForm from "./CopilotSidebarAgentsForm";
import CopilotSidebarAgentsRemoteForm from "./CopilotSidebarAgentsRemoteForm";
import CopilotSidebarAgentsList from "./CopilotSidebarAgentsList";
import { createAgent, updateAgent, createA2A } from "../../../../lib/services/copilotAgents";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotSidebarAgents');
const INITIAL_STATE = {
  step: 'list',
  agent: null
};
const REDUCER = (state, action) => {
  switch (action.type) {
    case 'LIST_STEP':
      return _objectSpread(_objectSpread({}, state), {}, {
        step: 'list',
        agent: null
      });
    case 'NEW_AGENT':
      return _objectSpread(_objectSpread({}, state), {}, {
        step: 'custom-form',
        agent: null
      });
    case 'NEW_REMOTE_AGENT':
      return _objectSpread(_objectSpread({}, state), {}, {
        step: 'remote-form',
        agent: null
      });
    case 'EDIT_AGENT':
      return _objectSpread(_objectSpread({}, state), {}, {
        step: 'custom-form',
        agent: action.payload
      });
    case 'EDIT_REMOTE_AGENT':
      return _objectSpread(_objectSpread({}, state), {}, {
        step: 'remote-form',
        agent: action.payload
      });
    default:
      return state;
  }
};
const CopilotSidebarAgentsTab = () => {
  const classes = useStyles();
  const [state, dispatch] = useReducer(REDUCER, INITIAL_STATE);
  const onNewAgent = useCallback(type => {
    if (!type || type === 'custom') {
      dispatch({
        type: 'NEW_AGENT'
      });
    } else if (type === 'a2a') {
      dispatch({
        type: 'NEW_REMOTE_AGENT'
      });
    }
  }, [dispatch]);
  const onSaveAgent = form => {
    let promise;
    if (form.id) {
      promise = updateAgent(form);
    } else {
      if (form.url) {
        promise = createA2A(form.url);
      } else {
        promise = createAgent(form);
      }
    }
    return promise;
  };
  const onCancelAgent = useCallback(() => {
    dispatch({
      type: 'LIST_STEP'
    });
  }, [dispatch]);
  const onUpdateAgent = useCallback(agent => {
    if (agent.type === 'custom' || !agent.type) {
      dispatch({
        type: 'EDIT_AGENT',
        payload: agent
      });
    } else if (agent.type === 'a2a') {
      dispatch({
        type: 'EDIT_REMOTE_AGENT',
        payload: agent
      });
    }
  }, [dispatch]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, state.step === 'list' && /*#__PURE__*/React.createElement(CopilotSidebarAgentsList, {
    key: "copilot-sidebar-agents-list",
    createAgent: onNewAgent,
    updateAgent: onUpdateAgent
  }), state.step === 'custom-form' && /*#__PURE__*/React.createElement(CopilotSidebarAgentsForm, {
    key: "copilot-sidebar-agents-custom-form",
    agent: state.agent,
    onCancel: onCancelAgent,
    onSave: onSaveAgent
  }), state.step === 'remote-form' && /*#__PURE__*/React.createElement(CopilotSidebarAgentsRemoteForm, {
    key: "copilot-sidebar-agents-remote-form",
    agent: state.agent,
    onCancel: onCancelAgent,
    onSave: onSaveAgent
  }));
};
export default CopilotSidebarAgentsTab;